import {Divider, Grid, MenuItem, Paper, TextField, Typography} from "@mui/material";
import {POSITION} from "./TireComponent";

export const VALUES_LEVELS = [
    {
        id: 1,
        label: "OPTIMO",
    },
    {
        id: 2,
        label:"REGULAR",
    },
    {
        id: 3,
        label:"CRITICO",
    },
];

const KEYS_VALUES ={
    aceite:"aceite",
    direccion:"direccion",
    refrigerante:"refrigerante",
    clutch:"clutch",
}

export function LevelsCheckComponent({titleTab="", report=null , setReport = null, isBus= true}){

    function handlingchangeValues(typeKey, value){
        setReport((oldData)=>{
            return{
                ...oldData,
                [typeKey]: value
            }
        })
    }

    return(
        <Paper elevation={12}style={{padding: "4vh"}} >
            <Grid item xs={12}
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center">
                <Typography>{` Revicion en los ${titleTab}`}</Typography>
            </Grid>

            <Divider/>

            <Grid container spacing={2} mt={2}>

                <Grid item xs={6} >

                    <TextField id={`${POSITION}-${KEYS_VALUES.aceite}`} fullWidth select label="Aceite" onChange={(event, value)=>handlingchangeValues(KEYS_VALUES.aceite, value.props.value)} defaultValue={report[KEYS_VALUES.aceite]}>
                        {
                            VALUES_LEVELS.map((things, index)=>(
                                <MenuItem key={`option-${things.label}-${index}`} value={things.id}>{things.label}</MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={6} >
                    <TextField id={`${POSITION}-${KEYS_VALUES.direccion}`} fullWidth select label="Direccion" onChange={(event, value)=>handlingchangeValues(KEYS_VALUES.direccion, value.props.value)} defaultValue={report[KEYS_VALUES.direccion]}>
                        {
                            VALUES_LEVELS.map((things, index)=>(
                                <MenuItem key={`option-${things.label}-${index}`} value={things.id}>{things.label}</MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                <Grid item xs={6} >
                    <TextField id={`${POSITION}-${KEYS_VALUES.refrigerante}`} fullWidth select label="refrigerante" onChange={(event, value)=>handlingchangeValues(KEYS_VALUES.refrigerante, value.props.value)} defaultValue={report[KEYS_VALUES.refrigerante]}>
                        {
                            VALUES_LEVELS.map((things, index)=>(
                                <MenuItem key={`option-${things.label}-${index}`} value={things.id}>{things.label}</MenuItem>
                            ))
                        }
                    </TextField>
                </Grid>

                {
                    false &&
                    <Grid item xs={6} >
                        <TextField id={`${POSITION}-${KEYS_VALUES.clutch}`} fullWidth select label="Clutch" onChange={(event, value)=>handlingchangeValues(KEYS_VALUES.clutch, value.props.value)} defaultValue={report[KEYS_VALUES.clutch]}>
                            {
                                VALUES_LEVELS.map((things, index)=>(
                                    <MenuItem key={`option-${things.label}-${index}`} value={things.id}>{things.label}</MenuItem>
                                ))
                            }
                        </TextField>
                    </Grid>
                }

            </Grid>

        </Paper>
    );
}